import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

import { DEFAULT_CHAR_LIMIT } from 'lib/GlobalConstants'

type params = {
  option: string
  charLimit?: number
  noWrap?: boolean
  typoGraphySx?: any
  componentPropsSx?: any
  placement?: any
}

export const shouldShowTooltip = (
  option: string,
  charLimit: number = DEFAULT_CHAR_LIMIT,
) => option?.length > charLimit

const OptionWithTooltip = ({
  option,
  charLimit = DEFAULT_CHAR_LIMIT,
  noWrap = true,
  typoGraphySx = {},
  componentPropsSx = {},
  placement = 'right-start',
}: params) => {
  return (
    <Tooltip
      title={option}
      placement={placement}
      data-testid="tooltip"
      componentsProps={{
        tooltip: {
          sx: componentPropsSx,
        },
      }}
      PopperProps={{
        popperOptions: {
          modifiers: [
            {
              name: 'preventOverflow',
              options: {
                altBoundary: true, // false by default
                tether: false,
              },
            },
          ],
        },
      }}
    >
      <Typography noWrap={noWrap} sx={typoGraphySx}>
        {`${option.substring(0, charLimit)}...`}
      </Typography>
    </Tooltip>
  )
}

export default OptionWithTooltip
